/**
 * 料金ページの契約期間による料金変動させるクラス
 */
export default class PriceDurationChange {
  constructor() {
    /**
     * selectに付けるclass名
     * @type {String}
     */
    this.inputElement = '.js-price-duration-change';
    /**
     * 料金変動表示する場所のclass名
     * @type {String}
     */
    this.valueElement = '.js-price-duration-value';
    this.init();
  }

  init() {
    const $input = document.querySelector(this.inputElement);
    $input.addEventListener('change', (event) => {
      const type = event.target.value;
      const $value = document.querySelector(this.valueElement);
      $value.innerText = $value.dataset[type] || 'Error';
    });
  }
}
